module.exports = __webpack_public_path__ + "static/media/6.ef733727.svg";